<template>
  <div class="offers-page">
    <div class="hero-card">
      <div>
        <h1>Oferta dhe Fushata</h1>
        <p>Menaxho fushatat dhe ofertat: orari, rregulla, parashikim dhe publikim.</p>
      </div>
      <div class="hero-badge">Oferta</div>
    </div>

    <OfertaTab />

    <ConfirmActionModal
      :open="confirmModal.open"
      :title="confirmModal.title"
      :message="confirmModal.message"
      :warning="confirmModal.warning"
      :details="confirmModal.details"
      :confirm-word="confirmModal.confirmWord"
      :confirm-label="confirmModal.confirmLabel"
      :danger="confirmModal.danger"
      :loading="confirmModal.loading"
      :allow-schedule="confirmModal.allowSchedule"
      :schedule-item-count="confirmModal.scheduleItemCount"
      :schedule-item-cap="priceScheduleItemCap"
      @confirm="onConfirmModalConfirm"
      @cancel="closeConfirmModal"
    />
    <ImportErrorModal
      :open="importErrorModal.open"
      :title="importErrorModal.title"
      :message="importErrorModal.message"
      :errors="importErrorModal.errors"
      :payload="importErrorModal.payload"
      @close="closeImportErrorModal"
      @download="downloadImportErrorJson"
    />
  </div>
</template>

<script>
import pricingOffersMixin from "./shared/pricingOffersMixin.js";
import ConfirmActionModal from "./shared/ConfirmActionModal.vue";
import ImportErrorModal from "./shared/ImportErrorModal.vue";
import OfertaTab from "./oferta/OfertaTab.vue";
import "./shared/pageStyles.css";

export default {
  name: "OfertaPage",
  pricingScreen: "oferta",
  components: { ConfirmActionModal, ImportErrorModal, OfertaTab },
  mixins: [pricingOffersMixin],
  provide() {
    return { po: this };
  },
};
</script>
